import { Component } from '@angular/core';
import { BrandingService } from '@core/services/branding.service';

/**
 * Slim replacement for the legacy 438px footer (reskin unit D).
 * Keeps the branding-mandated compliance content: copyright HTML and the
 * privacy/terms/licenses links. The privacy link is Get Covered's own notice
 * on every portal; renters/assurant flows no longer swap in Assurant's
 * carrier document. Social links were dropped per the redesign — pending
 * compliance sign-off (tracked in RESKIN_PROGRESS.md). The "Powered by Get
 * Covered" mark is not rendered here either; see the template comment.
 * Rendered by app.component inside the existing !iframeMode gate, exactly
 * like the footer it replaces.
 */
@Component({
    selector: 'app-flow-footnote',
    templateUrl: './flow-footnote.component.html',
    styleUrls: ['./flow-footnote.component.scss'],
    standalone: false
})
export class FlowFootnoteComponent {
  footerCopyrightHtml$ = this.brandingService.footerCopyrightHtml$;

  constructor(private brandingService: BrandingService) {}
}
